import { ToDoList_PirmaryThemes } from "./ToDoList_PirmaryThemes";
import { ToDoList_DrakThemes } from "./ToDoList_DrakThemes";
import { ToDoList_LightThemes } from "./ToDoList_LightThemes";

export const ListThemes = [
  { id: 1, name: "Default Themes", theme: ToDoList_PirmaryThemes },
  { id: 2, name: "Drak Themes", theme: ToDoList_DrakThemes },
  { id: 3, name: "Light Themes", theme: ToDoList_LightThemes },
];
